import { createFileRoute } from '@tanstack/react-router';

import { AppIntlProvider } from '@/lib/i18n/intl-provider';
import { ExternalShareView } from '@/components/external-share/external-share-view';
import { loadExternalShare } from '@/lib/public-chat/load-external-share';

export const Route = createFileRoute('/public/share/$token')({
  loader: async ({ params, location }) => loadExternalShare(params.token, location.searchStr),
  component: ExternalShareRoute,
});

function ExternalShareRoute() {
  const { token } = Route.useParams();
  const { info, locale, messages } = Route.useLoaderData();

  return (
    <AppIntlProvider locale={locale} messages={messages}>
      <ExternalShareView token={token} valid={info.valid} />
    </AppIntlProvider>
  );
}
